import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MinusCircleIcon, RefreshCwIcon, ActivityIcon, RepeatIcon } from 'lucide-react';
export function UniqueMethod() {
  const steps = [{
    title: 'Reducir',
    description: 'Eliminamos temporalmente los irritantes ocultos que te inflaman sin que te des cuenta.',
    icon: MinusCircleIcon
  }, {
    title: 'Reemplazar',
    description: 'Cambiamos inteligentemente ingredientes por opciones locales, económicas y amigables con tu panza.',
    icon: RefreshCwIcon
  }, {
    title: 'Regular',
    description: 'Calmamos el eje cerebro-intestino para que el estrés no bloquee tu digestión.',
    icon: ActivityIcon
  }, {
    title: 'Repetir',
    description: 'Consolidamos los aciertos para que la ligereza sea tu nuevo estado natural, no una excepción.',
    icon: RepeatIcon
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 px-4 bg-lightSage relative overflow-hidden" data-id="element-135">
      <div className="absolute top-0 right-0 w-64 h-64 bg-sage/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-136" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-white/40 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-137" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-139">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-140">
            El Método 4R Livianas
          </h2>
          <p className="text-xl text-brown/80 max-w-3xl mx-auto leading-relaxed" data-id="element-141">
            Un sistema diseñado específicamente para el ritmo de vida y el
            bolsillo argentino. No se trata de dejar de comer, sino de una
            limpieza estratégica de 7 días que le devuelve el ritmo natural a tu
            cuerpo.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-142">
          {steps.map((step, index) => <motion.div key={index} variants={cardVariants} className="bg-white p-8 rounded-3xl shadow-sm border border-sage/20 hover:shadow-md transition-shadow duration-300" data-id="element-143">
              <div className="flex items-start gap-6" data-id="element-144">
                <div className="w-14 h-14 rounded-2xl bg-sage/10 flex items-center justify-center flex-shrink-0 text-sage" data-id="element-145">
                  <step.icon className="w-7 h-7" data-id="element-146" />
                </div>
                <div data-id="element-147">
                  <h3 className="text-2xl font-serif font-bold mb-3 text-sage" data-id="element-148">
                    {step.title}
                  </h3>
                  <p className="text-brown/80 text-lg leading-relaxed" data-id="element-149">
                    {step.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}